<template>
    <div class="distance-calculator__result">
        <div class="distance-calculator__result__airports">
            <span class="distance-calculator__result__airports__icon">
                <CalculatorIcon :class="'takeoff-icon'" symbolId="airplane-take-off" />
                <span class="distance-calculator__result__airports__name">{{ departureName }}</span>
            </span>

            <span class="distance-calculator__result__airports__dotted-line"></span>

            <span class="distance-calculator__result__airports__icon">
                <CalculatorIcon :class="'landing-icon'" symbolId="airplane-landing" />
                <span class="distance-calculator__result__airports__name">{{ arrivalName }}</span>
            </span>
        </div>
        <hr class="distance-calculator__result__seperator">
        <span class="distance-calculator__result__distance" v-html="formattedResult"></span>
        <a v-if="show_button" class="link-button primary link-button-color" :href="button?.button_link">{{
            button?.button_text
        }}</a>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CalculatorIcon from '../CalculatorIcon/CalculatorIcon.vue';
import Distance, { InitialData } from '../../types/types';

const props = defineProps<{
    distance: Distance | null;
    arrivalName: string;
    departureName: string;
    resultText: InitialData | null;
    button: InitialData | null;
    show_button: InitialData | null;
}>();

const formattedResult = computed(() => {
    if (!props.resultText || !props.distance) return '';

    const successTemplate = props.resultText.success;
    const distanceValue = Math.round(props.distance.Distance);
    const compensationAmount = props.distance.CompensationAmount;

    return successTemplate
        .replace('[distance]', `<strong class="strong">${distanceValue} km</strong>`)
        .replace('[amount]', `<strong class="strong">€${compensationAmount}</strong>`);
});

</script>